import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseAction } from "@/Common/Stores/Actions/BaseAction";

class CommunicationsActions extends BaseAction {
    public LoadCommunicationsCounts(userId: string, throttle: number = 2500): void {
        var self = this;
        var requestData = { DoctorContactId: userId };

        // throttle updates
        if (communicationsStore.timeoutReferenceGetCount !== -1)
            clearTimeout(communicationsStore.timeoutReferenceGetCount);
        communicationsStore.timeoutReferenceGetCount = window.setTimeout(() => self.Execute(ServerOperations.Server.Myle_CountCommunication, requestData), throttle);
    }
}

export { CommunicationsActions };
